import { render, staticRenderFns } from "./BookUnit.vue?vue&type=template&id=bbea126a"
import script from "./BookUnit.vue?vue&type=script&lang=js"
export * from "./BookUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports